
export default function languageId(val) {
  switch (val) {
    case "zh-TW":
      return 2;
    case "en-us":
      return 3;
    case "es-es":
      return 5;
  }
  return 1;
}
 